export const getAlgoliaIndexName = (site) => {
  return `${process.env.NEXT_PUBLIC_SANITY_DATASET}-${site.countryCode}-pages`
}
